<template>
    <div class="html2pdf__page-break cardContainer elevation-2">
        <div class="cardContent" @click="emitClicked()">
            <div>
                <div class="flagRow">Österreichischer Sportkegel u. Bowlingverband</div>
                <div class="flagRowMiddle">{{pass.landesVerband}}</div>
                <div class="flagRow">{{pass.flagBottomRow}}</div>
                <div class="nrRow">{{pass.nrLabel}}: <span style="letter-spacing: 0.5px">{{pass.nr}}
                    </span> <span v-if="pass.duplikat && pass.type==='sp'" class="duplikat">(DUPLIKAT)</span>
                </div>
                <div :class="getNameClassList(pass)">{{pass.vorname}} {{pass.nachname}}</div>
            </div>
            <v-row class="bottomRow" no-gutters>
                <v-col class="shrink">
                    <div v-if="pass.url" class="passFotoContainer">
                        <img class="passFoto" :src="pass.url" alt="Passfoto"/>
                    </div>
                    <div v-else class="missingImage">Foto fehlt!</div>
                </v-col>
                <v-col class="grow text-center" style="padding-bottom: 4px">
                    <div class="dateLabel">Geburtsdatum</div>
                    <div class="date">{{pass.geburtsdatum}}</div>
                    <div class="dateLabelAlt">Ablaufdatum</div>
                    <div class="date redSpecial">{{pass.ablaufdatum}}</div>
                    <div class="nationalitaet">{{pass.nationalitaet}}</div>
                </v-col>
                <v-col class="shrink" >
                    <div style="padding-top: 4px">
                        <qr-code-display :qr-value="pass.qrCode" size="90"
                                         style="position: relative; width: 90px; height: 90px;"/>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import QrCodeDisplay from "@/utilities/components/qrCode/qrCodeDisplay";
export default {
    name: "paesse-drucken-karte",
    components: {QrCodeDisplay},
    props: ['pass'],
    methods: {
        emitClicked(){ this.$emit('clicked', this.pass);},
        getNameClassList(pass){
            let nameClass = 'nameRow ';
            const nameLength = pass.vorname.length + pass.nachname.length + 1
            const nameRatio = pass.nachname.length/pass.vorname.length
            if ( nameLength < 28 && nameRatio < 2 ) {
                nameClass += 'nameRow18'
            } else if ( nameLength >= 28 && nameLength < 29 ) {
                nameClass += 'nameRow17'
            } else if ( nameLength >= 29 && nameLength < 31 ) {
                nameClass += 'nameRow16'
            } else if ( nameLength >= 31 && nameLength < 33 ) {
                nameClass += 'nameRow15'
            } else if ( nameLength >= 33) {
                nameClass += 'nameRow14'
            }
            return nameClass
        },
    },
}
</script>

<style scoped>
    .cardContainer{width: 85.6mm; height: 53.8mm; padding: 2mm 2mm 0.5mm 2mm; text-align: center;
                   font-family: "Arial"; font-weight: bold; letter-spacing: 0.15px }
    .cardContent{width: 100%; height: 100%; position: relative}
    .flagRow{width: 100%; height: 4.8mm; font-size: 12px; color: white; background-color: #e30613}
    .flagRowMiddle{width: 100%; height: 4.8mm; font-size: 12px; color: black; font-weight: bold}
    .passFoto{height: 100%; }
    .passFotoContainer{width: 20mm; height: 24mm; overflow-y: hidden; overflow-x: hidden; margin-top: 4px}
    .missingImage{height: 25mm; width: 20mm; background-color: yellow; padding-top: 8px; margin-bottom: 8px}
    .bottomRow{position: absolute; bottom: 0; left: 0; right: 0}
    .nrRow{ font-size: 14px; line-height: 1; margin-top: 6px}
    .nameRow{line-height: 1; margin-top: 4px;}
    .nameRow18{font-size: 18px;}
    .nameRow17{font-size: 17px;}
    .nameRow16{font-size: 16px;}
    .nameRow15{font-size: 15px;}
    .nameRow14{font-size: 14px;}
    .dateLabel{font-size: 12px; line-height: 1; font-weight: normal; margin-top: 6px}
    .dateLabelAlt{font-size: 12px; line-height: 1; font-weight: normal; margin-top: 2px}
    .date{font-size: 12px; line-height: 1.4; font-weight: bolder}
    .redSpecial{color: #e30613}
    .nationalitaet { background-color: lightgray; max-width: 60px; margin: auto; margin-top: 4px;
        padding-bottom: 1px }
    .duplikat{background-color: yellow;}
</style>